export const introduce = {
  text: `### 使用方法
  + • 绿色：处于盈利状态。
  + • 红色：处于亏损状态。
  
  ### 指标原理
  + 所有转移（卖出）者的净盈亏情况。
  + 可用于观察当前价格下卖出者总体的盈利和亏损金额。在牛市中大部分卖出者处于盈利状态，在熊市中大部分卖出者处于亏损状态。`,
  height: 1330,
};